/** Safari Mockup 地址栏文案 */
export const MOCKUP_URL = 'app.perfectonlinechat.com';

/** 产品体验演示 URL：优先读环境变量，开发默认本地 Web，生产默认正式域名 */
export const PRODUCT_DEMO_URL =
  import.meta.env.VITE_APP_URL
  || (import.meta.env.PROD
    ? 'https://demw.pocai.chat/workspace-demo'
    : 'https://demw.pocai.chat/workspace-demo');

/**
 * 演示弹窗顶栏按钮：点击后直接给 iframe URL 追加 query（外部站需自行读取并开弹窗）
 * 例：最终变为 .../workspace-demo?openModal=1
 */
export const PRODUCT_DEMO_MODAL_QUERY = { openModal: '1' };

/** 生成 picsum 随机占位图 */
export function randomMockupImage(seed, width = 1200, height = 700) {
  const suffix = Math.floor(Math.random() * 10000);
  return `https://picsum.photos/seed/${seed}-${suffix}/${width}/${height}`;
}

/** 产品 Tab 对应占位图（画廊 / about 等静态图场景） */
export const PRODUCT_MOCKUP_IMAGES = {
  draft: 'https://picsum.photos/seed/poc-draft/1200/700',
  status: 'https://picsum.photos/seed/poc-status/1200/700',
  knowledge: 'https://picsum.photos/seed/poc-knowledge/1200/700',
  translate: 'https://picsum.photos/seed/poc-translate/1200/700',
};

/** 产品 Tab 对应演示视频（Safari Mockup 内容区） */
export const PRODUCT_MOCKUP_VIDEOS = {
  draft: '/videos/sc/home2-1.mp4',
  translate: '/videos/sc/home2-2.mp4',
  knowledge: '/videos/sc/home2-3.mp4',
  status: '/videos/sc/home2-4.mp4',
};

/** Infinite Grid 全屏画廊卡片数据 */
export const PRODUCT_GALLERY_CARDS = [
  {
    title: 'Reply Drafts',
    badge: 'Draft',
    description: 'Multi-channel conversations in one workspace.',
    tags: ['AI', 'Draft'],
    date: '2026',
    image: PRODUCT_MOCKUP_IMAGES.draft,
  },
  {
    title: 'Status Progress',
    badge: 'Status',
    description: 'Customer status updates automatically.',
    tags: ['CRM', 'Flow'],
    date: '2026',
    image: PRODUCT_MOCKUP_IMAGES.status,
  },
  {
    title: 'Knowledge Base',
    badge: 'Knowledge',
    description: 'AI drafts replies from your knowledge base.',
    tags: ['RAG', 'Reply'],
    date: '2026',
    image: PRODUCT_MOCKUP_IMAGES.knowledge,
  },
  {
    title: 'Translation',
    badge: 'Translate',
    description: 'Real-time Vietnamese / Chinese translation.',
    tags: ['i18n', 'Live'],
    date: '2026',
    image: PRODUCT_MOCKUP_IMAGES.translate,
  },
  {
    title: 'Team Workspace',
    badge: 'Team',
    description: 'Collaborative handoff across agents.',
    tags: ['Team', 'Sync'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-team/1200/700',
  },
  {
    title: 'Customer Timeline',
    badge: 'Timeline',
    description: 'Full context from first touch to close.',
    tags: ['History', 'View'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-timeline/1200/700',
  },
  {
    title: 'Smart Routing',
    badge: 'Route',
    description: 'Route high-intent leads to the right agent.',
    tags: ['Intent', 'Route'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-routing/1200/700',
  },
  {
    title: 'Analytics',
    badge: 'Insight',
    description: 'Conversion and response metrics at a glance.',
    tags: ['Data', 'KPI'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-analytics/1200/700',
  },
  {
    title: 'Channel Hub',
    badge: 'Omni',
    description: 'WhatsApp, email, and web chat in one inbox.',
    tags: ['Omni', 'Inbox'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-channel/1200/700',
  },
  {
    title: 'Approval Flow',
    badge: 'Review',
    description: 'Human-in-the-loop before every send.',
    tags: ['Review', 'Send'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-approval/1200/700',
  },
  {
    title: 'Template Library',
    badge: 'Template',
    description: 'Reusable reply templates for common cases.',
    tags: ['Template', 'Speed'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-template/1200/700',
  },
  {
    title: 'Mobile Ready',
    badge: 'Mobile',
    description: 'Serve customers from any device.',
    tags: ['Mobile', 'Anywhere'],
    date: '2026',
    image: 'https://picsum.photos/seed/poc-mobile/1200/700',
  },
];
